import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { Heading } from '@printdeal/ui-library';
import { AlternativeUpload, IAlternativeUpload } from '@printdeal/alternative-upload';

import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface Props {
  uploadFileDescription: string;
  dispatchEventCategory?: DispatchCategoriesAccount;
}

const DescribeYourIdea = ({
  uploadFileDescription,
  dispatchEventCategory = 'order_detail_interaction',
}: Props) => {
  const {
    setValue,
    register,
  } = useFormContext();

  const fieldName = 'attachments';
  register(fieldName);

  // Define the alternative upload handler, injecting the attachments into the react-hook-form values.
  const alternativeUploadHandler = useCallback(async (uploads: IAlternativeUpload[]) => {
    const attachments:IAlternativeUpload[] = [];

    // Convert the payload to a string[].
    if (uploads) {
      uploads.map(({ urls: { originalUrl } }: any) => attachments.push(originalUrl));
    }

    // Store the attachments in the react-hook-form values.
    await setValue('attachments', attachments);

    // Fire GA-event.
    dispatchAccountEvent(
      dispatchEventCategory,
      'file_design_field_interaction - fill',
      { fieldName: 'attachments' },
    );
  }, [dispatchEventCategory, setValue]);

  return (
    <section className="pd-flex pd-flex-col pd-gap-4">
      <Heading size="4">
        <FormattedMessage
          id="account.order.artwork.service.modal.body.step.three.title"
          defaultMessage="Step 3: Upload your files"
        />
      </Heading>
      <p>{uploadFileDescription}</p>
      <AlternativeUpload
        id="file-design-request"
        name="file-design-request"
        onChange={alternativeUploadHandler}
        dataLayerData={{ location: 'request_file_design_modal' }}
      />
    </section>
  );
};

export default DescribeYourIdea;
